import { render, staticRenderFns } from "./PswReset.vue?vue&type=template&id=d3418ee6&scoped=true&"
import script from "./PswReset.vue?vue&type=script&lang=js&"
export * from "./PswReset.vue?vue&type=script&lang=js&"
import style0 from "./PswReset.vue?vue&type=style&index=0&id=d3418ee6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3418ee6",
  null
  
)

export default component.exports